import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CUSTOMER_TYPES } from "../../Constants/config";
import { setApplicationType } from "../../Redux/store/accountTypeSlice";

const OnboardingHeader = ({ setCurrentStep }) => {
  const dispatch = useDispatch();
  const logoutDropdown = useRef(null);
  const customerTypeDropdown = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpenCustomer, setIsDropdownOpenCustomer] = useState(false);
  const username = useSelector((state) => state.user.username);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hoveredItemCustomer, setHoveredItemCustomer] = useState(null);
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState(0);
  const [selectedItemCustomer, setSelectedItemCustomer] = useState(1);
  const [selectedItemCustomerLabel, setSelectedItemCustomerLabel] =
    useState("Individual");
  const [currentType, setCurrentType] = useState(null);

  const [isConfirmAdvisor, setIsConfirmAdvisor] = useState(false);
  const [isConfirmChangeApplication, setIsConfirmChangeApplication] =
    useState(false);

  const menuItemspopUp = [
    {
      id: 1,
      label: "Delete Account",
      defaultIcon: "/trash.svg", // Replace with your default icon URL
      selectedIcon: "/trash-white.svg", // Replace with your selected icon URL
    },
    {
      id: 2,
      label: "Logout",
      defaultIcon: "/logout.svg",
      selectedIcon: "/logout-white.svg",
    },
  ];
  const handleChangeMenu = (id) => {
    setSelectedItem(id);
    // toggleMenu();
    if (id == 2) {
      localStorage.removeItem("jwtToken");
      navigate("/login");
    }
    setIsDropdownOpen(false);
  };
  const handleChangeMenuCustomer = (item) => {
    setIsConfirmChangeApplication(true);
    setCurrentType(item);
    setIsDropdownOpenCustomer(false);
  };
  const toggleDropdownCustomer = (event) => {
    event.stopPropagation(); // Prevent click from propagating to the document listener
    setIsDropdownOpenCustomer((prev) => !prev);
  };
  const toggleDropdown = (event) => {
    event.stopPropagation(); // Prevent click from propagating to the document listener
    setIsDropdownOpen((prev) => !prev);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        logoutDropdown.current &&
        !logoutDropdown.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
      if (
        customerTypeDropdown.current &&
        !customerTypeDropdown.current.contains(event.target)
      ) {
        setIsDropdownOpenCustomer(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <header className="pt-4 px-4 flex flex-wrap items-center justify-between py-0">
      {/* Left: Logo */}
      <div className="w-full md:w-auto flex-col md:flex-row flex justify-between items-center">
        <div className="flex">
          <img
            src="/ratified_logo_no_bg.svg"
            alt="Caprock Logo"
            className="h-12 sm:h-16 md:h-20 -mt-8 md:-mt-12"
          />
        </div>

        {/* Mobile Center Message Toggle (optional hamburger or info icon) */}
        <div className="flex justify-center w-full md:w-auto mt-2 md:mt-0">
          <div className="flex items-center space-x-2 border rounded-xl px-3 py-1.5 bg-yellow-50 border-yellow-300 max-w-sm mx-auto md:ml-[10vw]">
            <p className="text-xs text-black">
              Click here if you would like your advisor to complete this form on
              your behalf!
            </p>
            <button
              onClick={() => {
                setIsConfirmAdvisor(true);
              }}
              className="bg-black text-white text-xs rounded-full px-3 py-1 font-medium"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>

      {/* Right: Dropdowns (stacked on small screens, horizontal on md+) */}
      <div className="w-full md:w-auto flex flex-col md:flex-row items-start md:items-center space-y-2 md:space-y-0 md:space-x-4 mt-2 md:mt-0">
        {/* Application Type Dropdown */}
        <div ref={customerTypeDropdown} className="relative w-full md:w-auto">
          <div
            onClick={toggleDropdownCustomer}
            className={`flex items-center justify-between md:w-64 w-full rounded-xl p-2 cursor-pointer transition-colors duration-300 ${
              isDropdownOpenCustomer
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            <img
              src={
                !isDropdownOpenCustomer
                  ? "/document-text-black.svg"
                  : "/document-text.svg"
              }
              alt="Doc"
              className="w-6 h-6"
            />
            <div className="ml-2 flex-1">
              <p className="text-xs font-medium text-[#005A9C]">
                Change Application Type
              </p>
              <p
                className={`${
                  isDropdownOpenCustomer ? "text-white" : "text-black"
                } text-sm`}
              >
                {selectedItemCustomerLabel}
              </p>
            </div>
            <img
              src={
                !isDropdownOpenCustomer
                  ? "/chevron-down-black.svg"
                  : "/chevron-down.svg"
              }
              alt="Dropdown Icon"
              className={`w-4 h-4 transform transition-transform ${
                isDropdownOpenCustomer ? "rotate-180" : "rotate-0"
              }`}
            />
          </div>

          {/* Dropdown Menu */}
          {isDropdownOpenCustomer && (
            <div
              className="absolute mt-2 left-0 w-full md:w-64 bg-white rounded-lg shadow-lg z-[999]"
              onClick={(e) => e.stopPropagation()}
            >
              <ul className="py-2 px-2">
                {CUSTOMER_TYPES.map((item) => (
                  <li
                    key={item.value}
                    onMouseEnter={() => setHoveredItemCustomer(item.value)}
                    onMouseLeave={() => setHoveredItemCustomer(null)}
                    onClick={() => handleChangeMenuCustomer(item)}
                    className={`flex items-center px-4 py-2 rounded-md space-x-2 cursor-pointer transition-all duration-300 mb-1 ${
                      selectedItemCustomer === item.value
                        ? "bg-black text-white"
                        : ""
                    }
                    ${
                      hoveredItemCustomer === item.value
                        ? "bg-gray-400 text-white"
                        : ""
                    }
                    `}
                  >
                    <span className="text-sm">{item.label}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* Profile & Notifications */}
        <div
          ref={logoutDropdown}
          className="relative flex items-center space-x-4 w-full md:w-auto"
        >
          <div
            onClick={toggleDropdown}
            className={`flex items-center space-x-2 rounded-xl p-2 w-full md:w-auto cursor-pointer transition-colors duration-300 ${
              isDropdownOpen ? "bg-black text-white" : "bg-white text-black"
            }`}
          >
            <img
              src="/login-image.svg"
              alt="User Avatar"
              className="w-8 h-8 sm:w-10 sm:h-10 rounded-full"
            />
            <div className="sm:block text-sm whitespace-nowrap">
              <p className="font-medium text-[#005A9C]">Onboarding</p>
              <p className={`${isDropdownOpen ? "text-white" : "text-black"}`}>
                {username}
              </p>
            </div>
            <img
              src={
                !isDropdownOpen
                  ? "/chevron-down-black.svg"
                  : "/chevron-down.svg"
              }
              alt="Dropdown Icon"
              className="w-4 h-4"
            />
          </div>

          {isDropdownOpen && (
            <div
              className="absolute top-full mt-2 md:left-0 right-1 w-20 w-full md:w-44 bg-white rounded-lg shadow-lg z-[999]"
              onClick={(e) => e.stopPropagation()}
            >
              <ul className="py-2 px-2">
                {menuItemspopUp.map((item) => (
                  <li
                    key={item.id}
                    onMouseEnter={() => setHoveredItem(item.id)}
                    onMouseLeave={() => setHoveredItem(null)}
                    onClick={() => handleChangeMenu(item.id)}
                    className={`flex items-center px-4 py-2 rounded-md space-x-2 cursor-pointer transition-all duration-300 ${
                      hoveredItem === item.id || selectedItem === item.id
                        ? "bg-black text-white"
                        : "text-black hover:bg-black hover:text-white"
                    }`}
                  >
                    <img
                      src={
                        hoveredItem === item.id || selectedItem === item.id
                          ? item.selectedIcon
                          : item.defaultIcon
                      }
                      alt={item.label}
                      className="w-5 h-5"
                    />
                    <span className="text-sm">{item.label}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Notifications */}
          <button
            aria-label="Notifications"
            className="relative hover:text-gray-300 h-12 w-10 rounded-xl bg-white focus:outline-none ml-2"
          >
            <img src="/lamp.svg" alt="Notifications" className="ml-2 w-6 h-6" />
            <span className="absolute top-0 -right-2 bg-red-500 text-xs text-white rounded-full w-5 h-5 flex items-center justify-center">
              3
            </span>
          </button>
        </div>
        {isConfirmAdvisor && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
              <button className="absolute top-3 right-3 text-black text-xl font-bold">
                &times;
              </button>

              <div className="flex justify-center items-center mb-4">
                <div className="flex items-center justify-center">
                  <img
                    src="/warning-circle.svg"
                    alt="Add Template Icon"
                    className="h-10 w-10"
                  />
                </div>
              </div>

              <h2 className="text-lg font-medium mb-2">Are you sure?</h2>
              <p className="text-sm text-black mb-4">
                Do you want your advisor <br />
                <span className="font-medium italic">Advisor name</span> to fill out
                the application on your behalf?
              </p>

              <div className="flex justify-center space-x-4">
                <button
                  onClick={() => {
                    setIsConfirmAdvisor(false);
                  }}
                  className="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                >
                  No
                </button>
                <button
                  onClick={() => {
                    setIsConfirmAdvisor(false);
                  }}
                  className="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      {isConfirmChangeApplication && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
            <button className="absolute top-3 right-3 text-black text-xl font-bold">
              &times;
            </button>

            <div className="flex justify-center items-center mb-4">
              <div className="flex items-center justify-center">
                <img
                  src="/warning-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 className="text-lg font-medium mb-2">
              Are you sure you want to discard the current application?
            </h2>
            <p className="text-sm text-black mb-4">
              Changing your application type will result in discarding all the
              information currently filled, and you will be required to fill out
              the new application from the beginning.
            </p>

            <div className="flex justify-center space-x-4">
              <button
                onClick={() => {
                  setIsConfirmChangeApplication(false);
                }}
                className="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  setSelectedItemCustomer(currentType.value);
                  setSelectedItemCustomerLabel(currentType.label);
                  setHoveredItemCustomer(null);
                  setIsConfirmChangeApplication(false);
                  dispatch(setApplicationType(currentType.value));
                  setCurrentStep(1);
                }}
                className="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default OnboardingHeader;
